import { Component } from "@angular/core";
import { LogoMrnfComponent } from "./logo-mrnf/logo-mrnf.component";
import { LienExterneComponent } from "./lien-externe/lien-externe.component";
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'zzz-piv-piedpage',
    templateUrl: './piv-pied-page.component.html',
    styleUrls: ['./piv-pied-page.component.scss'],
    imports: [
        LogoMrnfComponent,
        LienExterneComponent,
        TranslateModule
    ]
})
export class PivPiedPageComponent {
  readonly annee_copyright = new Date().getFullYear();
}
